import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51472338"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "account" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("添加角色")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_6 = { class: "createOrUpdateMember" }
const _hoisted_7 = { class: "dialog-footer" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("取消")

import { defineComponent } from "vue";
import store from "@/store/index";
import { useStore } from "@/store/index";
import { ref, reactive } from "vue";
import tool from "@/utils/tool";
import router from "@/router/index";
import { ElButton, ElMessage, ElMessageBox } from "element-plus";
import type { ElForm, Action } from "element-plus";

    interface companyRoleVo {
      id: string;
      name: string;
      permissionIds:string
    }

    type FormInstance = InstanceType<typeof ElForm>;
    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const ustore = useStore();
    const loading = ref(true)
    

    const createOrEditFormData: companyRoleVo = {
      id: "",
      name: "",
      permissionIds:""
    };
    const bindData = reactive({
      permissions: [],
      pageParams: {
        curPage: 1,
        pageSize: 10,
        filtrate: {
          //status: "",
          keyword: "",
        },
      },
      pageResult: {
        status: 2000,
        msg: "成功",
        result: [],
        totalCount: 0,
      },
      createOrEditFormData: createOrEditFormData,
      createOrEditFormTitle: "",
     data: [],
     defaultProps : {
       children: 'children',
       label: 'label',
     }
    });

    const handleSizeChangeEvent = (value: any) => {
      bindData.pageParams.pageSize = value;
      bindData.pageParams.curPage = 1;
      searchEvent();
    };

    const handleCurrentChangeEvent = (value: any) => {
      bindData.pageParams.curPage = value;
      searchEvent();
    };

    const searchEvent = () => {
      store
        .dispatch("companyRoleModule/pageCompanyRoleList", bindData.pageParams)
        .then(
          (data) => {
            //成功
            bindData.pageResult = data;
            loading.value = false;
          },
          (error) => {
            console.log(error.msg);
          }
        );
    };

    const permissionEvent = () => {
      store
        .dispatch("companyRoleModule/listPermission", {})
        .then(
          (data) => {
            //成功
            bindData.data = data.result;
          },
          (error) => {
            console.log(error.msg);
          }
        );
    };

    const companyRolePermEvent = () => {
       const params = {
            id: bindData.createOrEditFormData.id,
          };
      store
        .dispatch("companyRoleModule/listCompanyRolePerm", params)
        .then(
          (data) => {
            //成功
            bindData.permissions = data.result;
          },
          (error) => {
            console.log(error.msg);
          }
        );
    };

    searchEvent();
    
    //新增或更新
    const createOrEditDialogVisible = ref(false);


    const showCreateFormEvent = () => {
      permissionEvent();
      bindData.permissions = [];
      createOrEditDialogVisible.value = true;
      bindData.createOrEditFormData = {
        id: "",
        name: "",
        permissionIds:"",
      };
      bindData.createOrEditFormTitle = "添加角色";
    };

    const showUpdateFormEvent = (index: number, row: companyRoleVo) => {
      permissionEvent();
      companyRolePermEvent();
      createOrEditDialogVisible.value = true;
      bindData.createOrEditFormData = row;
      bindData.createOrEditFormTitle = "修改角色";
    };

    const currentChecked = (nodeObj:any, SelectedObj:any) => {
      bindData.permissions = SelectedObj.checkedKeys  // 这是选中的节点的key数组
 
    }

    const deleteEvent = (index: number, row: companyRoleVo) => {
      ElMessageBox.confirm(`您确定要删除 ${row.name}  吗?`)
        .then(() => {
          const params = {
            id: row.id,
          };
          store.dispatch("companyRoleModule/deleteCompanyRole", params).then(
            (data) => {
              //成功
              ElMessage.success("删除成功.");
              searchEvent();
            },
            (error) => {
              ElMessageBox.alert(error.msg, "系统消息", {
                confirmButtonText: "关闭",
                callback: (action: Action) => {},
              });
            }
          );
        })
        .catch(() => {
          // catch error
        });
    };

    const companyRoleFormRef = ref<FormInstance>();

    const validateCode = (rule: any, value: any, callback: any) => {
      if (value === "") {
        callback(new Error("请输入账号"));
      } else {
        callback();
      }
    };

    const validateName = (rule: any, value: any, callback: any) => {
      if (value === "") {
        callback(new Error("请输入名称"));
      } else {
        callback();
      }
    };

    const companyRoleRules = reactive({
      code: [{ required: true, validator: validateCode, trigger: "blur" }],
      name: [{ required: true, validator: validateName, trigger: "blur" }],
    });

    const submitCompanyRoleForm = (formEl: FormInstance | undefined) => {
      if (!formEl) return;
      formEl.validate((valid) => {
        if (valid) {
           bindData.createOrEditFormData.permissionIds = JSON.stringify(bindData.permissions);
          store
            .dispatch(
              "companyRoleModule/saveCompanyRole",
              bindData.createOrEditFormData
            )
            .then(
              (data) => {
                //成功
                createOrEditDialogVisible.value = false;
                if (
                  data.result &&
                  data.result.password &&
                  data.result.password.length > 0
                ) {
                  ElMessageBox.alert(
                    `保存成功. 初始密码:${data.result.password}`,
                    "系统消息",
                    {
                      confirmButtonText: "关闭",
                      callback: (action: Action) => {},
                    }
                  );
                } else {
                  ElMessage.success("保存成功");
                }

                searchEvent();
              },
              (error) => {
                ElMessageBox.alert(error.msg, "系统消息", {
                  confirmButtonText: "关闭",
                  callback: (action: Action) => {},
                });
              }
            );
        } else {
          console.log("error submit!");
          return false;
        }
      });
    };


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_tree = _resolveComponent("el-tree")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, { class: "account-search" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
          class: "account-search-lt"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  placeholder: "请输入关键字搜索",
                  size: "large",
                  modelValue: _unref(bindData).pageParams.filtrate.keyword,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(bindData).pageParams.filtrate.keyword) = $event)),
                  modelModifiers: { trim: true },
                  onKeyup: _withKeys(searchEvent, ["enter"])
                }, null, 8, ["modelValue", "onKeyup"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { class: "project-list-search-lt-btn" }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElButton), {
                  type: "primary",
                  size: "large",
                  onClick: searchEvent
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_unref(ElButton), {
          class: "account-search-rt",
          type: "primary",
          size: "large",
          onClick: showCreateFormEvent
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      data: _unref(bindData).pageResult.result,
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "name",
          label: "角色名称",
          width: "180"
        }),
        _createVNode(_component_el_table_column, {
          prop: "memberCodes",
          label: "账号",
          width: "180"
        }),
        _createVNode(_component_el_table_column, {
          prop: "memberNames",
          label: "姓名",
          width: "180"
        }),
        _createVNode(_component_el_table_column, {
          prop: "createTime",
          label: "操作时间",
          width: "180"
        }),
        _createVNode(_component_el_table_column, {
          prop: "creator",
          label: "操作人",
          width: "180"
        }),
        _createVNode(_component_el_table_column, {
          fixed: "right",
          label: "操作",
          width: "200"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_unref(ElButton), {
              type: "text",
              size: "small",
              onClick: ($event: any) => (showUpdateFormEvent(scope.$index, scope.row))
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_unref(ElButton), {
              type: "text",
              size: "small",
              onClick: ($event: any) => (deleteEvent(scope.$index, scope.row))
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, loading.value]
    ]),
    _createVNode(_component_el_container, { class: "account-page_toolbar" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_pagination, {
          currentPage: _unref(bindData).pageParams.curPage,
          "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => ((_unref(bindData).pageParams.curPage) = $event)),
          "page-size": _unref(bindData).pageParams.pageSize,
          "onUpdate:page-size": _cache[3] || (_cache[3] = ($event: any) => ((_unref(bindData).pageParams.pageSize) = $event)),
          "page-sizes": [10, 20, 50, 100],
          layout: "total, sizes, prev, pager, next, jumper",
          total: _unref(bindData).pageResult.totalCount,
          "onUpdate:total": _cache[4] || (_cache[4] = ($event: any) => ((_unref(bindData).pageResult.totalCount) = $event)),
          onSizeChange: handleSizeChangeEvent,
          onCurrentChange: handleCurrentChangeEvent
        }, null, 8, ["currentPage", "page-size", "total"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: createOrEditDialogVisible.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((createOrEditDialogVisible).value = $event)),
      title: _unref(bindData).createOrEditFormTitle,
      "onUpdate:title": _cache[9] || (_cache[9] = ($event: any) => ((_unref(bindData).createOrEditFormTitle) = $event)),
      width: "40%"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_7, [
          _createVNode(_unref(ElButton), {
            type: "primary",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (submitCompanyRoleForm(companyRoleFormRef.value)))
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }),
          _createVNode(_unref(ElButton), {
            onClick: _cache[7] || (_cache[7] = ($event: any) => (createOrEditDialogVisible.value = false))
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_form, {
            ref_key: "companyRoleFormRef",
            ref: companyRoleFormRef,
            model: _unref(bindData).createOrEditFormData,
            "status-icon": "",
            rules: _unref(companyRoleRules),
            "label-width": "120px",
            class: "companyRoleForm"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "名称",
                prop: "name"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _unref(bindData).createOrEditFormData.name,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(bindData).createOrEditFormData.name) = $event)),
                    type: "text",
                    autocomplete: "off"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "功能权限" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_tree, {
                    data: _unref(bindData).data,
                    "show-checkbox": "",
                    "node-key": "id",
                    "default-expanded-keys": [2, 3],
                    "default-checked-keys": _unref(bindData).permissions,
                    props: _unref(bindData).defaultProps,
                    onCheck: currentChecked
                  }, null, 8, ["data", "default-checked-keys", "props"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
}
}

})